import { ComponentProps } from "../types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Component({ component }: ComponentProps) {
	return <></>;
}

export default Component;
